import { render, staticRenderFns } from "./ConnectedMobileSidebar.vue?vue&type=template&id=06654b7e&"
import script from "./ConnectedMobileSidebar.vue?vue&type=script&lang=js&"
export * from "./ConnectedMobileSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports